export default {
  getCurrentQuestion: (state) => {
    return state.currentQuestion
  },
  getLeadGenQuestions: (state) => {
    return state.leadGenQuestions
  },
  getAnswers: (state) => {
    return state.answers
  },
  getTotalSteps: (state) => {
    return state.totalSteps
  },
  getPropertyType: (state) => {
    return state.propertyType
  },
  getOrgGuid: (state) => {
    return state.orgGuid
  },
  getOrgType: (state) => {
    return state.orgType
  },
  getSettings: (state) => {
    return state.settings
  },
  getLoanOfficerTitle: (state) => {
    return state.settings.loanOfficerTitle
  },
  getAnswer: (state) => (questionKey) => {
    return state.answers.find(answer => answer.question === questionKey)?.answer
  }
}
